export default __webpack_public_path__ + "static/media/green_settings_button.8fa41413.svg";